import { BreadcrumbItem } from '@/interfaces/breadcrumbItem';

import { flat } from './flat';

/**
 * Pobiera listę elementów do wyświetlenia w breadcrumbsach
 *
 * @export
 * @param {*} routes
 * @param {any[]} [parents]
 * @returns {any[]}
 */
export function getBreadcrumbItems(routes: any[], parents?: BreadcrumbItem[]): BreadcrumbItem[] {
  return flat(routes.map(route => routeItemToCrumbs(route, parents)));
}

/**
 * Mapuje element routera na element breadcrumbów
 *
 * @param {*} route
 * @param {BreadcrumbItem[]} [parents]
 * @returns {(BreadcrumbItem | BreadcrumbItem[])}
 */
function routeItemToCrumbs(route: any, parents?: BreadcrumbItem[]): BreadcrumbItem | BreadcrumbItem[] {
  const crumb: BreadcrumbItem = { route: { name: route.name, ...route.meta.breadcrumb }, parents };
  if (route.children) {
    return crumbWithChildren(route, crumb);
  }
  return crumb;
}

/**
 * Zwraca breadcrumb wraz z dziećmi
 *
 * @param {*} route
 * @param {BreadcrumbItem} crumb
 * @returns
 */
function crumbWithChildren(route: any, crumb: BreadcrumbItem) {
  const children = getBreadcrumbItems(route.children, crumb.parents ? [...crumb.parents, crumb] : [crumb]);
  return [crumb, ...children];
}
